export const CONTENT_TYPES = Object.freeze({
    TITLE: "TITLE",
    ALT: "ALT",
    TAB: "TAB",
});
